import { Component, Input } from '@angular/core';

@Component({
  selector: 'trackify-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() isCustomized: boolean = false; 
}
